<template>
  <mag-layout :title="title" @caleclick="switchSilder">
    <div class="content">
      <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
      <div class="left chapters">
        <div class="listtitle">單元閱讀</div>
        <router-link
          :to="`/read/${brandCode}/${issueId}/0`"
          v-if="coverchepter.thumbImage"
          class="chaptercard firstchepter"
        >
          <image-loader :src="coverchepter.thumbImage[0]" alt="" />
          <div class="chaptertitlte">{{ clipTitle(coverchepter.title) }}</div>
        </router-link>
        <router-link
          :to="`/read/${brandCode}/${issueId}/${index + 1}`"
          v-for="(chapter, index) in leftchapters"
          :key="chapter.mnId"
          class="chaptercard"
        >
          <image-loader :src="chapter.thumbImage[0]" alt="" />
          <div class="chaptertitlte">{{ clipTitle(chapter.title) }}</div>
        </router-link>
      </div>
      <router-link class="coverCt" :to="`/read/${brandCode}/${issueId}`">
        <image-loader class="cover" :src="cover" width="auto" />
        <div class="mark">
          <span class="iconfont iconread read"></span>
          <span class="readtip">閱讀整本</span>
        </div>
      </router-link>

      <div class="right chapters">
        <div class="listtitle">單元閱讀</div>
        <router-link
          :to="`/read/${brandCode}/${issueId}/${index + 7}`"
          v-for="(chapter, index) in rightchapters"
          :key="chapter.mnId"
          class="chaptercard"
        >
          <image-loader :src="chapter.thumbImage[0]" alt="" />
          <div class="chaptertitlte">{{ clipTitle(chapter.title) }}</div>
        </router-link>
      </div>
    </div>
    <silder
      :show.sync="showsilder"
      :brandCode="brandCode"
      @close="switchSilder"
    ></silder>
    <template v-solt="ft">
      <mfooter />
    </template>
  </mag-layout>
</template>

<script>
import MagLayout from "../_layout/mag_layout";
import Silder from "../../components/Silder";
import Footer from "../Footer";
import { get } from "../../libs/request";
import { API } from "../../libs/consts";
import { cacheIssue, getCacheIssue } from "../../libs/utils";

export default {
  name: "MagPage",
  components: {
    "mag-layout": MagLayout,
    silder: Silder,
    mfooter: Footer,
  },
  data() {
    return {
      loading: false,
      title: "",
      cover: "",
      showsilder: false,
      leftchapters: [],
      rightchapters: [],
      coverchepter: {},
    };
  },
  computed: {
    issueId() {
      return this.$route.params.issueId;
    },
    brandCode() {
      return this.$route.params.brandCode;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      const item = getCacheIssue(this.issueId);
      if (item) {
        this.title = item.mgName;
        this.cover = item.cover;
        this.coverchepter = item.pageList[0];
        this.leftchapters = item.pageList.slice(1, 7);
        this.rightchapters = item.pageList.slice(7);
      } else {
        this.loading = true;
        get(API.magz.brand.issue(this.issueId), {
          issueId: this.issueId,
          brandCode: this.brandCode,
        })
          .then((rps) => {
            if (rps.errMsg == API.Code.ok) {
              this.title = rps.data.mgName;
              this.cover = rps.data.cover;
              this.coverchepter = rps.data.pageList[0];
              this.leftchapters = rps.data.pageList.slice(1, 7);
              this.rightchapters = rps.data.pageList.slice(7);
              cacheIssue(this.issueId, rps.data);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    switchSilder() {
      this.showsilder = !this.showsilder;
    },
    clipTitle(title) {
      if (title.length > 14) return title.substr(0, 12) + "...";
      return title;
    },
  },
  watch: {
    issueId() {
      this.loadData();
    },
  },
};
</script>
<style scoped src="./index.css" />